import heroImage from '../styles/img/announcement/hero.png';
import iconOnboarding from '../styles/img/announcement/icon-onboarding.svg';
import iconTalentHub from '../styles/img/announcement/icon-talent-hub.svg';
import iconRecommends from '../styles/img/announcement/icon-recommends.svg';
import iconProgression from '../styles/img/announcement/icon-progression.svg';

export const announcementContent = {
  hero: {
    title: "Welcome to the New ASTRNT Experience",
    subtitle: "A platform designed around how you actually work — from the first assessment to the final talent decision.",
    image: heroImage,
  },
  features: [
    {
      title: "Intelligent Onboarding",
      description: "AI instantly detects your company profile and prevents duplicate accounts. Getting your team ready to work in minutes.",
      icon: iconOnboarding,
    },
    {
      title: "A Unified Talent Hub",
      description: "Run university admissions, external recruitment, and internal leadership programs from a single platform. The workspace dynamically adapts to fit your exact context.",
      icon: iconTalentHub,
    },
    {
      title: "ASTRNT Recommends",
      description: "Reduce cognitive load with progressive AI scoring. From early signals to comprehensive assessment data, our engine turns complex data into clear, actionable recommendations—empowering you to make the final call with absolute confidence.",
      icon: iconRecommends,
    },
    {
      title: "Frictionless Hiring",
      description: "Eliminate hiring friction. Track and move candidates seamlessly from evaluation to final offer. Automated notifications keep every candidate updated at each stage — no one is left waiting.",
      icon: iconProgression,
    }
  ],
  faqSections: [
    {
      sectionTitle: "General",
      faqs: [
        {
          question: "What is changing in the platform?",
          answer: "We've rebuilt the platform with a more modern interface, improved performance, and a stronger foundation for future enhancements.",
        },
        {
          question: "Why was the platform rebuilt?",
          answer: "This rebuild allows us to provide a more reliable experience today while enabling faster innovation and new features in the future.",
        },
      ],
    },
    {
      sectionTitle: "Data & Account",
      faqs: [
        {
          question: "Is our data and credits safe?",
          answer: "Yes, completely. All your data, credits, and account settings remain unchanged and fully secure.",
        },
        {
          question: "Will my historical data still be available?",
          answer: "Yes, all historical data is fully accessible in the new platform.",
        },
        {
          question: "Do we need to set anything up again?",
          answer: "No. All your settings, jobs, and data are automatically available in the new platform.",
        },
      ],
    },
    {
      sectionTitle: "Access & Transition",
      faqs: [
        {
          question: "Can we still use the old platform?",
          answer: "Yes, the legacy platform will remain accessible during the transition period.",
        },
        {
          question: "How long will the old platform be available?",
          answer: "The legacy platform will be available until Jun 2, 2026, giving you time to transition comfortably. After this date, we will fully transition to the new platform.",
        },
        {
          question: "How do we access the new platform?",
          answer: "You can access the new platform using your existing account. No new setup or registration is required.",
        },
      ],
    },
    {
      sectionTitle: "Features & Usage",
      faqs: [
        {
          question: "Are there changes to features or workflows?",
          answer: "Most core features remain the same, with improvements in usability and performance. Some features may be enhanced or reorganized for a better experience.",
        },
        {
          question: "Will anything be removed?",
          answer: "No critical features are removed. If there are any changes, we will communicate them clearly in advance.",
        },
      ],
    },
    {
      sectionTitle: "Pricing",
      faqs: [
        {
          question: "Is there any additional cost?",
          answer: "No. This is a platform update, not a change to your current plan or pricing.",
        },
      ],
    },
    {
      sectionTitle: "Support",
      faqs: [
        {
          question: "Will there be guidance for the new platform?",
          answer: "Yes, we will provide updated guides and support to help you get familiar with the new experience.",
        },
        {
          question: "Who should we contact if we need help?",
          answer: "You can reach out to our support team or your account manager anytime for assistance.",
        },
      ],
    },
    {
      sectionTitle: "Looking Ahead",
      faqs: [
        {
          question: "Will there be more updates after this?",
          answer: "Yes, this rebuild is the foundation for continuous improvements, and you can expect more enhancements moving forward.",
        },
      ],
    },
  ],
  cta: {
    text: "Experience the New Dashboard",
    link: "https://app.astrnt.co"
  }
};
